import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionWrapper } from './SectionWrapper';
const deliverables = [{
  title: "El Manual 'Ya No me Habla'",
  desc: 'La estrategia paso a paso para transformar la dinámica del hogar en 72 horas.'
}, {
  title: 'La Pausa de los 4 Segundos',
  desc: 'El ejercicio mental exacto para no perder los estribos en el momento del conflicto.'
}, {
  title: 'Guiones de Rescate',
  desc: "Frases palabra por palabra para responder a portazos, insultos y al famoso 'no me pasa nada'."
}, {
  title: 'El Protocolo de Puerta Cerrada',
  desc: 'Cómo manejar el aislamiento sin invadir su privacidad ni perder el control.'
}, {
  title: 'Checklist de Emergencia',
  desc: 'Qué hacer cuando sientes que vas a explotar y cómo retomar la calma en segundos.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function DeliverablesSection() {
  return <SectionWrapper altBg data-id="element-15">
      <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-12 text-center" data-id="element-16">
        Lo que encontrarás dentro
      </h2>

      <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="space-y-4" data-id="element-17">
        {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start p-6 bg-card rounded-sm shadow-warm border border-subtle" data-id="element-18">
            <div className="flex-shrink-0 mt-1" data-id="element-19">
              <CheckIcon className="w-6 h-6 text-amber" data-id="element-20" />
            </div>
            <div className="ml-4" data-id="element-21">
              <h3 className="text-xl font-heading font-semibold text-primary mb-1" data-id="element-22">
                {item.title}
              </h3>
              <p className="text-secondary font-body" data-id="element-23">{item.desc}</p>
            </div>
          </motion.div>)}
      </motion.div>
    </SectionWrapper>;
}